import { DialogProps } from '@material-ui/core/Dialog';
import Dialog from '@material-ui/core/Dialog';
import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';
import { DialogSidebar } from './DialogSidebar';
import styles from './StyledDialog.module.scss';

export class StyledDialogCore extends React.Component<
    DialogProps & {
        actions?: React.ReactNode;
        open: boolean;
        size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | false;
        modal?: boolean;
        fullHeight?: boolean;
        titleComponent?: React.ReactNode;
        actionsComponent?: React.ReactNode;
        alertContent?: React.ReactNode;
        contentComponent?: React.ReactNode;
        testId?: string;
        preventSideBarCollapse?: boolean;
        onExited?(): void;
        onRequestClose?(event: SyntheticEvent<{}>): void;
        sidebarRender?(props: { collapsed: boolean }): React.ReactNode;
    }
> {
    public static muiName = 'Dialog';

    public state = {
        sidebarCollapsed: window.innerWidth < 1279
    };

    public toggleSidebar = (): void => {
        this.setState({
            sidebarCollapsed: !this.state.sidebarCollapsed
        });
    };

    public render() {
        const {
            size,
            modal,
            fullHeight,
            open,
            onRequestClose,
            sidebarRender,
            titleComponent,
            contentComponent,
            actionsComponent,
            alertContent,
            children,
            testId,
            preventSideBarCollapse,
            ...otherProps
        } = this.props;

        const dialogBodyStyles = classNames(styles.dialogBody, {
            [styles.extraSmall]: this.props.size === 'xs' || this.props.size === 'xxs',
            [styles.small]: this.props.size === 'sm',
            [styles.medium]: this.props.size === 'md',
            [styles.large]: this.props.size === 'lg'
        });

        const sideBarOpen = !!preventSideBarCollapse ? true : !!sidebarRender && !this.state.sidebarCollapsed;

        const mainAreaStyles = classNames(styles.mainArea, {
            [styles.sideBarLockedOpen]: !!preventSideBarCollapse,
            [styles.hasSideBar]: !!sidebarRender,
            [styles.sideBarOpen]: sideBarOpen
        });

        const paperStyles = classNames(styles.dialogPaper, {
            [styles.fullHeight]: fullHeight,
            [styles.extraExtraSmallWidth]: this.props.size === 'xxs',
            [styles.large]: this.props.size === 'lg'
        });

        const maxWidth = this.props.size !== 'xxs' ? this.props.size : 'xs';

        return (
            <Dialog
                {...otherProps}
                data-test-id={`dialog_${testId}`}
                classes={{
                    paper: paperStyles,
                    paperWidthXs: styles.extraSmallWidth,
                    paperWidthSm: styles.smallWidth,
                    paperWidthMd: styles.mediumWidth,
                    paperFullScreen: styles.largeWidth
                }}
                fullWidth
                maxWidth={maxWidth}
                onClick={this.handleDialogBodyClick}
                disableBackdropClick={modal}
                open={open}
                onExited={this.props.onExited}
                onClose={onRequestClose}
            >
                {titleComponent}
                <div className={dialogBodyStyles}>
                    {sidebarRender && (
                        <DialogSidebar
                            preventSideBarCollapse={preventSideBarCollapse}
                            collapsed={this.state.sidebarCollapsed}
                            onToggle={this.toggleSidebar}
                            sidebarRender={sidebarRender}
                        />
                    )}
                    <div className={mainAreaStyles}>
                        {alertContent}
                        {contentComponent}
                        {actionsComponent}
                        {children}
                    </div>
                </div>
            </Dialog>
        );
    }

    private handleDialogBodyClick = (event: React.MouseEvent) => {
        event.stopPropagation();
    };
}
